module.exports = __webpack_public_path__ + "img/flag-de.635c4838.png";